"use client";

import { useSidebar } from "@/contexts/SidebarContext";
import GlobalSidebar from "./GlobalSidebar";
import MobileHeader from "./MobileHeader";
import { cn } from "@/lib/utils";
import { usePathname } from "next/navigation";

export default function MainLayout({ children }: { children: React.ReactNode }) {
    const { isCollapsed } = useSidebar();
    const pathname = usePathname();

    // Check if we are on a public/auth page where sidebar is hidden
    const isPublic = [
        "/auth/login",
        "/auth/register",
        "/auth/forgot-password",
        "/",
        "/public/verify-email"
    ].includes(pathname || "") || pathname?.startsWith("/public");

    return (
        <div className="min-h-screen flex flex-col md:flex-row text-slate-100 bg-slate-950">
            {/* Mobile Header - only visible on mobile */}
            <MobileHeader />

            {/* Sidebar - hidden on mobile until toggled */}
            <GlobalSidebar />

            <main
                className={cn(
                    "flex-1 transition-all duration-300 ease-in-out min-h-screen flex flex-col",
                    // Add top padding on mobile for the fixed header
                    !isPublic && "pt-14 md:pt-0",
                    // Add left margin on desktop for sidebar
                    !isPublic && (isCollapsed ? "md:ml-16" : "md:ml-64")
                )}
            >
                {children}
            </main>
        </div>
    );
}
